import { TextSettingsTelegram } from "@project/shared-types";
import { useState } from "react";
import CloseSvg from "../../assets/taiga-uikit/icons/close.svg?react";
import { Button } from "../../components/button/button";
import { Divider } from "../../components/Divider/Divider";
import { FixedPage } from "../../components/FixedPage/FixedPage";
import { Link } from "../../components/link/link";
import { Push } from "../../components/Push/Push";
import { Switcher } from "../../components/Switcher/Switcher";
import { TabButton } from "../../components/Tab/TabButton";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _colorText, _size, _sizeHeading, _sizeText, _style } from "../../core/core";
import { useNotiflySettings } from "../hooks/useNotiflySettings";
import "./SettingNotifly.css";

interface SettingNotiflyProps {
    handleClose: () => void;
}

export const SettingNotifly = ({
    handleClose
}: SettingNotiflyProps) => {
    const [activeTab, setActiveTab] = useState(0);
    const { settings, getSettingsByTab, changeSection } = useNotiflySettings();

    const ConstructSettings = (start_prefix: 'job' | 'order') => {

        const currentSettings = getSettingsByTab(activeTab);
        if (!currentSettings) {
            return;
        }
        return currentSettings.filter((setting) => setting.type.startsWith(start_prefix)).map((setting) => {
            return <>
                <div key={setting.type} className="setting-notifly__option">
                    <div className="setting-notifly__option-text">
                        <Text size={_sizeText.m}>{TextSettingsTelegram[setting.type].text}</Text>
                        <Text size={_sizeText.s} color={_colorText.neutral}>{TextSettingsTelegram[setting.type].desc}</Text>
                    </div>
                    <div className="setting-notifly__option-switcher">
                        <Switcher
                            checked={setting.enabled}
                            onChange={() => {
                                changeSection(activeTab, setting.type)
                            }}
                        />
                    </div>
                </div>

                <Divider />
            </>
        })

    }
    return (
        <FixedPage is_active={true} set_is_active={handleClose}>
            <div className="setting-notifly">
                <div className="setting-notifly-header">
                    <Title type={_sizeHeading.h3}>  Настройте уведомления</Title>
                    <Button style={_style.flat} onClick={handleClose}>
                        <CloseSvg />
                    </Button>
                </div>
                <div className="setting-notifly-body">
                    <div className="setting-notifly__tabs">
                        <TabButton onClick={() => setActiveTab(0)} active={activeTab === 0}>Телеграм</TabButton>
                        <TabButton onClick={() => setActiveTab(1)}
                            active={activeTab === 1}
                        >Почта</TabButton>
                    </div>
                    <div className="setting-notifly__content">
                        <div className="setting-notifly__content-item">
                            {activeTab === 0 && (
                                <Push id={"tg"}
                                    is_close_btn={false}
                                    is_icon={false}
                                    text={<> Уведомления будут приходить от <Link size={_size.S} style={_style.linkDefault} link="https://t.me/hm_vvlab_bot">бота</Link></>} />
                            )}

                            <div className="setting-notifly__content-cards">
                                <Text size={_sizeText.mbold}>
                                    По заказу
                                </Text>
                                <div className="setting-notifly__content-cards-options">
                                    {ConstructSettings('order')}
                                </div>
                            </div>
                            <div className="setting-notifly__content-cards">

                                <Text size={_sizeText.mbold}>
                                    По заданиям
                                </Text>
                                <div className="setting-notifly__content-cards-options">
                                    {ConstructSettings('job')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-notifly__footer">
                    <Button width={'100%'} style={_style.primary} onClick={handleClose}>Сохранить</Button>
                </div>
            </div>
        </FixedPage >
    );
}